import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useContent } from '../../context/ContentContext';

export default function CtaBanner({ onEnquire }) {
  const { t, lang } = useLanguage();
  const { content } = useContent();
  const c = content?.ctaBanner?.[lang] || t.ctaBanner;
  return (
    <section data-testid="cta-banner" className="py-16" style={{ backgroundImage: 'linear-gradient(135deg, #0A3F22 0%, #1B6B3D 100%)' }}>
      <div className="mx-auto max-w-3xl px-4 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="font-heading font-black text-3xl sm:text-4xl text-white mb-3">{c.title}</h2>
          <p className="text-white/70 mb-8 text-base">{c.subtitle}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              data-testid="cta-farmer-btn"
              onClick={onEnquire}
              className="px-8 py-4 rounded-lg font-heading font-bold text-white transition-all duration-300 hover:scale-105"
              style={{ backgroundColor: '#D97706', boxShadow: '0 4px 20px rgba(217,119,6,0.4)' }}
            >
              {c.btnFarmer}
            </button>
            <Link
              to="/dealers"
              data-testid="cta-dealer-btn"
              className="px-8 py-4 rounded-lg font-heading font-bold text-white transition-all duration-300 hover:scale-105 inline-block text-center"
              style={{ backgroundColor: 'rgba(255,255,255,0.15)', border: '2px solid rgba(255,255,255,0.4)' }}
            >
              {c.btnDealer}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
